<script>
import baseMixin from '@/mixins/baseMixin'
import BookingConfirmationsListItem from '@/components/booking/booking-confirmations-list-item.vue'

export default {
  name: 'BookingConfirmations',
  components: { BookingConfirmationsListItem },
  mixins: [baseMixin],
  props: {
    confirmations: {
      type: Array,
      required: true,
    },
    contacts: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      showAddForm: false,
    }
  },
  computed: {
    hasSelectableConfirmations() {
      return this.contacts.filter(
        (x) => !this.confirmations.map((y) => y.contactId).includes(x.id)
      )
    },
  },
  methods: {
    save(payload) {
      this.$emit('save', payload)
    },
    remove(id) {
      this.$emit('remove', id)
    },
  },
}
</script>

<template>
  <section>
    <header class="d-flex align-center justify-space-between">
      <p class="text-h6 text--primary">
        {{ $t('bookingCreate.confirmationsTitle') }}
      </p>
      <v-btn
        id="booking-confirmations-list__add-confirmation-btn"
        small
        color="blue"
        class="custom-elevation white--text mb-2"
        :disabled="hasSelectableConfirmations.length === 0"
        @click="showAddForm = true"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('bookingCreate.confirmationsAddBtn') }}
      </v-btn>
    </header>
    <article>
      <BookingConfirmationsListItem
        v-if="showAddForm"
        class="booking-confirmations-list__add-form mb-2"
        :create="true"
        :contacts="contacts"
        :confirmation="{}"
        :confirmations="confirmations"
        @save="save"
        @closeForm="showAddForm = false"
      />

      <transition-group name="expand">
        <BookingConfirmationsListItem
          v-for="confirmation of confirmations"
          :key="
            `booking-confirmations-list-item_confirmation_${confirmation.fullName}`
          "
          class="booking-confirmations-list__list-item mb-2"
          :contacts="contacts"
          :confirmation="confirmation"
          :confirmations="confirmations"
          @save="save"
          @remove="remove"
        />
      </transition-group>
    </article>
  </section>
</template>
